const type = "USER/";

export const userConstants = {
  //#region User listing constants
  GET_BASIC_DETAIL_SUCCESS: "GET_USER_BASIC_DETAILS_SUCCESS",
  GET_BASIC_DETAIL_FAILURE: "GET_USER_BASIC_DETAILS_FAILURE",
  GET_BASIC_DETAIL_REQUEST: "GET_USER_BASIC_DETAILS_REQUEST",
  
  SEND_VERIFICATION_EMAIL_REQUEST: `${type}SEND_VERIFICATION_EMAIL_REQUEST`,
  SEND_VERIFICATION_EMAIL_SUCCESS: `${type}SEND_VERIFICATION_EMAIL_SUCCESS`,
  SEND_VERIFICATION_EMAIL_FAILURE: `${type}SEND_VERIFICATION_EMAIL_FAILURE`,
  
  VALIDATE_VERIFICATION_EMAIL_TOKEN_REQUEST: "VALIDATE_VERIFICATION_EMAIL_TOKEN_REQUEST",
  VALIDATE_VERIFICATION_EMAIL_TOKEN_SUCCESS: "VALIDATE_VERIFICATION_EMAIL_TOKEN_SUCCESS",
  VALIDATE_VERIFICATION_EMAIL_TOKEN_FAILURE: "VALIDATE_VERIFICATION_EMAIL_TOKEN_FAILURE",
  
  CHANGE_PASSWORD: "CHANGE_PASSWORD",
  CHANGE_PASSWORD_SUCCESS: "CHANGE_PASSWORD_SUCCESS",
  
  LOGOUT: "USERS_LOGOUT",
  LOGOUT_SUCCESS: "USERS_LOGOUT_SUCCESS",
};